import { useCallback, useMemo, useState } from 'react';
import { RecapContext, RecapContextType } from './RecapContext';

interface RecapProviderProps {
  children: React.ReactNode;
}

export const RecapProvider = ({ children }: RecapProviderProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  const toggleDrawer = useCallback(() => {
    setIsDrawerOpen(prev => !prev);
  }, []);

  const contextValue: RecapContextType = useMemo(
    () => ({
      isDrawerOpen,
      openDrawer,
      closeDrawer,
      toggleDrawer,
    }),
    [isDrawerOpen, openDrawer, closeDrawer, toggleDrawer]
  );

  return (
    <RecapContext.Provider value={contextValue}>{children}</RecapContext.Provider>
  );
};

